<template>
  <div class="matchmaker-center-page">
    <div class="page-hero">
      <div class="hero-top">
        <button class="hero-back" @click="$router.go(-1)">
          <img src="../assets/back.png" alt="back" />
        </button>
        <div class="hero-actions">
          <!-- <button class="hero-action" @click="scoreClick">
            <van-icon name="points" />
            <span>我的积分</span>
          </button>
          <button class="hero-action" @click="$router.push({ path: '/matchMakerInfo' })">
            <van-icon name="edit" />
            <span>编辑资料</span>
          </button> -->

          <!-- <button class="hero-action" @click="relationshipClick">
            <span>关系总览</span>
          </button> -->
          <button class="hero-action" @click="handleSignOut">
            <span>退出登录</span>
          </button>
        </div>
      </div>

      <div class="hero-copy">
        <div class="hero-title">红娘中心</div>
        <div class="hero-desc">会员查询、浏览记录、跟进状态统一在这里处理</div>
      </div>
      <!-- 
      <div class="stats-card">
        <div class="stat-item">
          <div class="stat-number">{{ infoList.length }}</div>
          <div class="stat-label">已缓存会员</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ reocrdList.length }}</div>
          <div class="stat-label">浏览记录</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ followInfoList.length }}</div>
          <div class="stat-label">我的跟进</div>
        </div>
      </div> -->
    </div>

    <div class="page-content">
      <div class="tab-strip">
        <button class="tab-pill" :class="{ active: activeState === 'query' }" @click="memberClick">会员查询</button>
        <button class="tab-pill" :class="{ active: activeState === 'record' }" @click="reocrdClick">浏览记录</button>
        <button class="tab-pill" :class="{ active: activeState === 'follow' }" @click="followClick">我的跟进</button>
        <!-- <button class="tab-pill" :class="{ active: activeState === 'relationship' }"
          @click="relationshipClick">关系总览</button> -->
      </div>

      <div class="content-card">
        <div class="content-head">
          <div>
            <div class="content-title">{{ currentSection.title }}</div>
            <div class="content-desc">{{ currentSection.desc }}</div>
          </div>
        </div>

        <MemberQuery v-if="queryVisible === 'memberQuery' && visible" />
        <MemberCheck v-if="queryVisible === 'memberCheck' && visible" />
        <MemberFollow v-if="queryVisible === 'memberFollow' && visible" />
      </div>
    </div>

    <TabBar active-key="matchmakerCenter" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import MemberQuery from "@/components/matchmakerCenter/memberQuery.vue";
import MemberCheck from "@/components/matchmakerCenter/memberCheck.vue";
import MemberFollow from "@/components/matchmakerCenter/memberFollow.vue";
import { getMemberList, getFollowUpMembers, getBrowsingHistory } from "../api/user";
import { mapGetters } from "vuex";
import { Toast } from "vant";

export default {
  components: { MemberQuery, MemberCheck, MemberFollow, TabBar },
  data() {
    return {
      queryVisible: "memberQuery",
      activeState: "query",
      visible: false
    };
  },
  computed: {
    ...mapGetters(["role", "infoList", "reocrdList", "followInfoList"]),
    currentSection() {
      if (this.activeState === "record") {
        return {
          title: "浏览记录",
          desc: "查看已浏览过的会员，便于快速回访。"
        };
      }
      if (this.activeState === "follow") {
        return {
          title: "我的跟进",
          desc: "集中处理当前跟进中的会员与进度。"
        };
      }
      if (this.activeState === "relationship") {
        return {
          title: "关系总览",
          desc: "查看所有红娘的跟进配对关系。"
        };
      }
      return {
        title: "会员查询",
        desc: "按条件筛选会员并进入详情页继续撮合。"
      };
    }
  },
  methods: {
    reocrdClick() {
      this.activeState = "record";
      this.queryVisible = "memberCheck";
      this.visible = false;
      this.$store.dispatch("SetQueryName", "check");
      getBrowsingHistory(this.$store.getters.baseInfo.id).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("SetReocrdList", res.data);
          this.visible = true;
          this.isBackTop();
        } else {
          Toast.fail({ message: `${res.msg}` });
        }
      });
    },
    followClick() {
      this.activeState = "follow";
      this.queryVisible = "memberFollow";
      this.visible = false;
      this.$store.dispatch("SetQueryName", "follow");
      this.$store.dispatch("SET_Page", { name: "followPage", page: 1 });
      const params = {
        page: 1,
        pageSize: 10,
        matchmakerInfoId: this.$store.getters.baseInfo.id
      };
      getFollowUpMembers(params).then(res => {
        if (res.code === 20000) {
          this.visible = true;
          this.$store.dispatch("SetFollowInfoList", res.data.items);
          this.isBackTop();
        }
      });
    },
    isBackTop() {
      if (this.$store.getters.activityBack) {
        setTimeout(() => {
          document.documentElement.scrollTop = 0;
        });
      }
    },
    memberClick() {
      this.activeState = "query";
      this.visible = false;
      this.queryVisible = "memberQuery";
      this.$store.dispatch("SetQueryName", "query");
      this.$store.dispatch("SET_QueryList", { page: 1 });
      const queryPage = this.$store.getters.queryPage;
      const educationData = ["大专", "本科", "硕士", "博士", "高中及以下"];
      const params = {
        sex: queryPage.sex ? (queryPage.sex === "男" ? 1 : 2) : "",
        education: queryPage.education ? educationData.indexOf(queryPage.education) + 1 : "",
        minimumBirthday: queryPage.minimumBirthday ? new Date(queryPage.minimumBirthday + "-01-01").toISOString() : "",
        maximumBirthday: queryPage.maximumBirthday ? new Date(queryPage.maximumBirthday + "-12-31").toISOString() : "",
        minimumHeight: queryPage.minimumHeight,
        maximumHeight: queryPage.maximumHeight,
        hometown: queryPage.hometown,
        keyWord: queryPage.serialNumber,
        page: 1,
        pageSize: 10
      };
      getMemberList(params).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch("SetInfoList", res.data.items);
          this.visible = true;
          this.isBackTop();
        } else {
          Toast.fail({ message: `${res.msg}` });
        }
      });
    },
    relationshipClick() {
      this.$router.push({ path: '/followUpRelationshipOverview' });
    },
    scoreClick() {
      this.activeState = "score";
      this.$router.push({ path: "/myScore" });
    },
    handleSignOut() {
      this.$store.dispatch("RemoveToken");
      if (location.href.indexOf("?") !== -1) {
        window.location.replace("/mbc/index.html#/");
      } else {
        this.$router.push({ path: "/login" });
      }
    }
  },
  created() {
    if (this.$store.getters.queryListName === "query") {
      this.memberClick();
    } else if (this.$store.getters.queryListName === "check") {
      this.reocrdClick();
    } else {
      this.followClick();
    }
  }
};
</script>
<style scoped lang="less" src="../style/matchmakerCenter.less" />



// WEBPACK FOOTER //
// src/views/matchmakerCenter.vue